<template>
    <div class="tabs horizontal" v-bind="$attrs">
        <div class="w-100 flex align-items-center" :class="[`justify-content-${position}`]">
            <ul class="tab-list" role="tabList" :class="[type, type === 'single_pill' ? 'gap-2' : '']">
                <li 
                    v-for="tab in tabs"
                    :key="tab.id" class="tab-list__item"
                    tabIndex="0" role="tabItem" 
                    :class="{ 'active': isTabActive(tab) }" :aria-selected="isTabActive(tab)"
                    @click="goToTab(tab.route)"
                >
                    <template v-if="isIcon">
                        <IconSvg :name="tab.iconName" :fill="tab.iconFill" :width="getIconSize(tab.size)" :height="getIconSize(tab.size)" />
                    </template>
                    <span>
                        {{ tab.id }}
                    </span>
                </li>
            </ul>
        </div>
        
        <div class="tab-panel h-auto" role="tabPanel">
            <div class="tab-content h-auto">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
import IconSvg from "../icons/Icon-Svg.vue";

export default {
    name: "LinkedTabs",
    components: { IconSvg },

    props: {
        list: {
            type: Array,
            default: () => [],
        },
        isIcon: {
            type: Boolean,
            default: false,
        },
        type: { 
            type: String, 
            default: "line",
            validator: (value) => {
                return ["line", "pill", "single_pill"].includes(value);
            },
        },
        position: { 
            type: String, 
            default: "start",
            validator: (value) => {
                return ["start", "center", "end"].includes(value);
            },
        },
        size: { 
            type: String, 
            default: "sm",
            validator: (value) => {
                return ["xs", "sm", "md", "lg"].includes(value);
            },
        },
    },

    data() {
        return {
            tabs: this.list, 
        };
    },

    methods: {
        isTabActive(tab) {
            if (this.$route.path.includes(this.$to_simple_lowercase(tab.id))) {
                return true;
            } else if (this.$route.name === tab.name) {
                return true;
            } else {
                return false;
            }
        },

        getIconSize() {            
            switch (this.size) {
            case "xs": return "12px";
            case "sm": return "16px";
            case "md": return "24px";
            case "lg": return "36px";
            
            default: return "12px";
            }
        },

        goToTab(route) {
            return this.$router.push(`/dashboard/${route}`);
        },
    },
};
</script>